//Helper function related fo projects
import PropTypes from "prop-types";

export const projectShape = {
    "Project Title": PropTypes.string.isRequired,
    hubName: PropTypes.string.isRequired,
    Focus: PropTypes.string,
    "Community link": PropTypes.string,
    Website: PropTypes.string,
    Address: PropTypes.string.isRequired,
    Latitude: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
        .isRequired,
    Longitude: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
        .isRequired,
};

export const ensureLatAndLng = x => {
    return Boolean(parseFloat(x.Latitude)) && Boolean(parseFloat(x.Longitude));
};
export const centerFromProject = project => {
    return [parseFloat(project.Longitude), parseFloat(project.Latitude)];
};



// WEBPACK FOOTER //
// ./src/modules/project.js